/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eisubscalesituationdevelopmentstrong4Inputs */



/**
* | output |
* | --- |
* | "You understand the general patterns of how emotions unfold, and that helps you predict how an emotional state changes in different situations." |
*
* @param {Eisubscalesituationdevelopmentstrong4Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const eisubscalesituationdevelopmentstrong4 = /** @type {((inputs?: Eisubscalesituationdevelopmentstrong4Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eisubscalesituationdevelopmentstrong4Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("You understand the general patterns of how emotions unfold, and that helps you predict how an emotional state changes in different situations.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Entiendes los patrones generales de cómo se desarrollan las emociones, y eso te ayuda a prever cómo cambia el estado emocional en distintas situaciones.")
	return /** @type {LocalizedString} */ ("Ты понимаешь общие закономерности развития эмоций, и это помогает тебе предсказывать, как меняется эмоциональное состояние в разных ситуациях.")
});
export { eisubscalesituationdevelopmentstrong4 as "eiSubscaleSituationDevelopmentStrong" }